export default __webpack_public_path__ + "static/media/氨氮分析仪（水杨酸）.4a2da527.png";